import React, { useState } from "react";
import { useNavigate,Link } from "react-router-dom"; // Import for routing
import { FaPhoneAlt, FaSearch, FaCheck, FaArrowRight } from "react-icons/fa";
import "../Css/DriverService.css";
import DriverImage from "../assets/service-5.jpg";




const DriverService = () => {

    const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  // List of your services
  const services = [
  { name: "Patient Care", path: "/services/patient-care-service-in-mumbai" },
  { name: "Baby Care", path: "/services/baby-care-service-in-mumbai" },
  { name: "House Maid", path: "/services/house-maid-service-in-mumbai" },
  { name: "Cooking", path: "/services/cooking-service-in-mumbai" },
  { name: "Driver", path: "/services/driver-service-in-mumbai" },
  { name: "Home Cleaning", path: "/services/home-cleaning-service-in-mumbai" },
  { name: "Japa Maid", path: "/services/japa-maid-service-in-mumbai" },
];

  // Filter logic
  const filteredServices = services.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  
  return (
    <div className="DriverService-page">
      {/* HERO SECTION - RETAINED AS REQUESTED */}
      <section className="DriverService-hero">
        <div className="DriverService-overlay">
          <div className="DriverService-hero-content">
            <h1>Driver Service</h1>
            <p>
              <span><a href="/">Home</a></span> / <span className="active">Driver Service</span>
            </p>
          </div>
        </div>
      </section>

      {/* SQUARE PREMIUM CONTENT */}
      <section className="main-section">
        <div className="container-square">
          <div className="content-layout">
            
            {/* Main Content Area */}
            <div className="article-box">
              <div className="square-img-holder">
                <img src={DriverImage} alt="Driver Service Services" />
                <div className="img-overlay-label">PREMIUM SERVICE</div>
              </div>

              <div className="text-header">
                <h2 className="title-bold">Professional Driver Services in Mumbai – Safe & Reliable Rides</h2>
                <h4 className="subtitle-line">Skilled Driver Services Mumbai</h4>
              </div>

              <div className="body-description">
                <p>SVK Maid Service is your trusted choice for Driver Service in Mumbai, providing professional, reliable, and safe driving solutions for families and businesses alike. We understand that commuting in Mumbai can be stressful, which is why our goal is to make travel simple, comfortable, and worry-free.</p>
                <p>With SVK Maid Service, you can easily Hire Driver in Mumbai who is skilled, experienced, and dependable. Whether you need a full-time driver for daily use, a part-time driver for occasional trips, or someone to manage special errands, we have the right solution to fit your lifestyle.</p>
                <p>Our Professional Driver Mumbai are trained to handle all types of vehicles and traffic conditions with care and professionalism. Punctuality, safety, and courtesy are always our priorities. Families and businesses across Mumbai trust us to provide consistent and high-quality driving services that make life easier and more convenient.</p>
                
              </div>

              {/* Why Choose - Modern Square Grid */}
              <div className="why-choose-square">
                <h3>Why Choose SVK Maid Service?</h3>
                <div className="grid-features">
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Affordable Driver in Mumbai:</strong> Get reliable and professional drivers without stretching your budget.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Best Driver Services in Mumbai:</strong> Skilled and background-verified drivers for safe, efficient travel.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Driver Service in Mumbai:</strong> Flexible options for daily commuting, airport transfers, long trips, or special occasions.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Professional Driver Mumbai:</strong> Trained to manage vehicles responsibly while maintaining professionalism and discretion.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Flexible Scheduling:</strong> Full-time, part-time, or temporary driver services tailored to your requirements.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Dedicated Support:</strong> Our customer service team ensures seamless communication and smooth service.</p>
                  </div>
                </div>
              </div>

              <div className="summary-footer-box">
                <p>Our drivers at SVK Maid Service do more than just drive—they are committed to providing peace of mind. You can focus on your work, family, or other priorities, knowing that your transportation needs are handled safely and efficiently.</p>
              </div>
              <div className="summary-footer-box">
                <p>Choosing SVK Maid Service means you’re opting for a reliable partner who provides the Best Driver Services in Mumbai. Our Professional Driver Mumbai ensures punctuality, safety, and a smooth experience every time, making us the preferred choice for households and businesses across the city.</p>
              </div>
              <div className="summary-footer-box">
                <p>Experience convenience and peace of mind by hiring a driver through SVK Maid Service. Hire Driver in Mumbai today and enjoy professional, affordable, and dependable driving services designed to make your life easier and stress-free.</p>
              </div>
            </div>

            {/* Square Sidebar */}
            <aside className="sidebar-square">
              {/* ACTIVE SEARCH BOX */}
      <div className="search-container-premium">
        <div className="search-square">
          <input
            type="text"
            placeholder="SEARCH SERVICES..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button><FaSearch /></button>
        </div>

        {/* Search Results Dropdown */}
        {searchTerm && (
          <div className="search-results-dropdown">
            {filteredServices.length > 0 ? (
              filteredServices.map((service, index) => (
                <div
                  key={index}
                  className="result-item"
                  onClick={() => navigate(service.path)}
                >
                  {service.name}
                </div>
              ))
            ) : (
              <div className="no-result">No services found</div>
            )}
          </div>
        )}
      </div>

              <div className="list-widget">
                <h5>OUR SERVICES</h5>
                <ul className="square-links">
  <li>
    <Link to="/services/patient-care-service-in-mumbai">
      Patient Care <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/baby-care-service-in-mumbai">
      Baby Care <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/house-maid-service-in-mumbai">
      House Maid <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/cooking-service-in-mumbai">
      Cooking <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link
      to="/services/driver-service-in-mumbai"
      className="active-item"
    >
      Driver <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/home-cleaning-service-in-mumbai">
      Home Cleaning <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/japa-maid-service-in-mumbai">
      Japa Maid <FaArrowRight />
    </Link>
  </li>
</ul>
              </div>

<div className="contact-box-square">
  <div className="cta-overlay-square">
    <div className="cta-icon-square">
      <FaPhoneAlt />
    </div>
    <h3 className="cta-title-square">Call us Today!</h3>
    <a href="tel:+919152151180" className="cta-phone-square">
      +91 91521 51180
    </a>
    <a href="mailto:info@svkmaidservice.com" className="cta-email-square">
      info@svkmaidservice.com
    </a>
  </div>
</div>
            </aside>

          </div>
        </div>
      </section>
    </div>
  );
};

export default DriverService;